<template>
  <div class="workbench-home">
    <WorkbenchTitle title="工作台"></WorkbenchTitle>

    <div class="project-list">
      <div class="project-line">
        <div class="project-item" @click="clickProjectItem('jcyl')">
          <img src="~@/assets/logo/base.png" alt="" class="project-icon" />
          <div class="project-name">
            基层医疗机构呼吸疾病<br />规范化防诊治体系与<br />能力建设
          </div>
        </div>
        <div class="project-item" @click="clickProjectItem('glxt')">
          <img src="~@/assets/logo/manage.png" alt="" class="project-icon" />
          <div class="project-name">PCCM专培过程<br />管理系统</div>
        </div>
        <div class="project-item" @click="clickProjectItem('vte')">
          <img src="~@/assets/logo/thrombus.png" alt="" class="project-icon" />
          <div class="project-name">
            全国肺栓塞和静脉血栓<br />形成防治能力建设项目
          </div>
        </div>

        <div class="project-item" @click="clickProjectItem('pccm')">
          <img src="~@/assets/logo/zxdx.png" alt="" class="project-icon" />
          <div class="project-name">
            PCCM科规范化建设项目<br />（二、三级医院）
          </div>
        </div>
      </div>
      <!-- <div class="project-line">
        <div class="project-item" @click="clickProjectItem('zxdx')">
          <img src="~@/assets/logo/zxdx1.png" alt="" class="project-icon" />
          <div class="project-name">PCCM专修单修<br />信息管理平台</div>
        </div>
        <div class="project-item" @click="clickProjectItem('pxzx')">
          <img src="~@/assets/logo/train.png" alt="" class="project-icon" />
          <div class="project-name">
            基层呼吸系统疾病早起筛查<br />干预能力提升项目
          </div>
        </div>
        <div class="project-item" @click="clickProjectItem('www')">
          <img src="~@/assets/logo/logo.png" alt="" class="project-icon" />
          <div class="project-name">中国呼吸专科联合体</div>
        </div>
        <div class="project-item" @click="clickProjectItem('hospital')">
          <img src="~@/assets/logo/hospital.png" alt="" class="project-icon" />
          <div class="project-name">互联网医院</div>
        </div>
      </div> -->
      <div class="project-line">
        <div class="project-item" @click="clickProjectItem('ild')">
          <img src="~@/assets/logo/ild_logo.png" alt="" class="project-icon" />
          <div class="project-name">
            ILD间质性肺疾病项目<br />（二、三级医院）
          </div>
        </div>
      </div>
    </div>

    <!-- <WorkbenchTitle title="数据中心"></WorkbenchTitle> -->

    <!-- <div class="project-list">
      <div class="project-line">
        <div class="project-item" @click="clickProjectItem('sjjc')">
          <img
            src="~@/assets/logo/data_policy.png"
            alt=""
            class="project-icon"
          />
          <div class="project-name">
            数据决策<br />
            （数据分析/可视化）
          </div>
        </div>
        <div class="project-item" @click="clickProjectItem('sjgl')">
          <img
            src="~@/assets/logo/data_manage.png"
            alt=""
            class="project-icon"
          />
          <div class="project-name">
            数据管理<br />
            （数据归集/数据服务）
          </div>
        </div>
      </div>
    </div> -->
    <transition :duration="{ enter: 100 }" enter-active-class="animated fadeIn">
      <router-view :key="key"></router-view>
    </transition>
  </div>
</template>
<script>
import WorkbenchTitle from "@/components/WorkbenchTitle";
import { mapMutations } from "vuex";
export default {
  name: "Workbench",
  components: {
    WorkbenchTitle,
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    clickProjectItem(project_id = "") {
      if (project_id) {
        if (project_id === "vte") {
          window.open("https://www.thrombosischina.cn/");
        } else if (project_id === "jcyl") {
          window.open("https://pccm.cardpc.org/");
        } else if (project_id === "glxt") {
          window.open("http://pccm.weidijia.cn/");
        } else if (project_id === "pxzx") {
          window.open("https://training.chinancrm.org.cn/auth/login/");
        } else if (project_id === "sjgl") {
          window.open(
            "http://testdmp.hxylt.org.cn/thirdPartLogin.html?thirdpart=hxylt"
          );
        } else if (project_id === "sjjc") {
          window.open("http://lingde.palmyou.com/");
        } else if(project_id === "pccm"){
          this["SET_DATA"]({
            platform: project_id,
          });
          this.$router.push({
            name: "WorkbenchRole",
          });
        }else if(project_id === "ild"){
          // ild

          this["SET_DATA"]({
            platform: project_id,
          });
          this.$router.push({
            name: "WorkbenchRole",
          });
        }
      }
    },
    showBind() {
      this.$router.push({
        name: "WorkbenchBind",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
